"use client";

import React, { useState, useRef } from "react";
import Link from "next/link";
import { FaChevronDown } from "react-icons/fa";

export default function Slider() {
  const [isPlaying, setIsPlaying] = useState(true);
  const desktopVideoRef = useRef(null);
  const mobileVideoRef = useRef(null);

  const togglePlayPause = () => {
    const nextState = !isPlaying;
    setIsPlaying(nextState);

    [desktopVideoRef, mobileVideoRef].forEach((ref) => {
      if (ref.current) {
        if (nextState) {
          ref.current.play().catch(() => { });
        } else {
          ref.current.pause();
        }
      }
    });
  };

  const scrollToNextSection = () => {
    const productsEl = document.getElementById("products");
    if (productsEl) {
      productsEl.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div dir="ltr" className="relative w-full h-screen overflow-hidden bg-black select-none">
      {/* 1. Desktop & Tablet Video */}
      <video
        ref={desktopVideoRef}
        src="/ALLNEWCAMRYProgressBeyondPerfection01_1.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="hidden md:block absolute inset-0 w-full h-full object-cover"
      />

      {/* 2. Mobile Video */}
      <video
        ref={mobileVideoRef}
        src="/ALLNEWCAMRYProgressBeyondPerfection01_1.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="block md:hidden absolute inset-0 w-full h-full object-cover"
      />

      {/* 3. Dark Gradient Backdrop Overlay matching Figma */}
      <div
        className="absolute inset-0 z-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.1) 30%, rgba(0,0,0,0.1) 65%, rgba(0,0,0,0.85) 100%)",
        }}
      />

      {/* 4. Hero Content Overlay */}
      <div className="relative z-20 w-full h-full max-w-[1700px] mx-auto px-6 md:px-16 lg:px-24 flex flex-col justify-end pb-6 md:pb-10 pt-20">

        {/* Hero Title & Button: Pinned to Bottom-Left on Desktop & Tablet (Image 1), Bottom-Center on Mobile (Image 2) */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left gap-4 md:gap-5 mb-6 md:mb-8 w-full">
          <h1 className="text-[40px] sm:text-[50px] md:text-[60px] lg:text-[70px] font-anjoman-thin text-white tracking-wide leading-tight">
            Beyond Motion
          </h1>

          <Link
            href="/products/20"
            className="w-full max-w-[180px] ml-2 md:w-auto text-center border border-white/70 text-white px-6 py-2 md:px-8 md:py-2.5 text-[15px] md:text-[20px] font-anjoman-extralight tracking-wider rounded-md md:rounded-lg hover:bg-white hover:text-black transition-all bg-black/20 "
          >
            انتخاب خودرو
          </Link>
        </div>

        {/* Bottom Controls Bar: Scroll Chevron (Center) & Pause/Play Button (Bottom Right) */}
        <div className="flex items-center justify-between w-full">
          {/* Left Spacer for balance */}
          <div className="w-10 md:w-11" />

          {/* Center Scroll Chevron Indicator */}
          <button
            onClick={scrollToNextSection}
            className="text-white/60 hover:text-white transition-colors cursor-pointer p-2 animate-bounce"
            aria-label="اسکرول به پایین"
          >
            <FaChevronDown className="text-sm md:text-base" />
          </button>

          {/* Pause / Play Toggle Button (Bottom Right Corner matching Figma Image 1 & 2) */}
          <button
            onClick={togglePlayPause}
            className="w-[56px] h-[56px] rounded-full border border-white/40 text-white/90 hover:text-white hover:border-white/70 bg-black/20 backdrop-blur-md flex items-center justify-center transition-all cursor-pointer hover:scale-105 active:scale-95"
            aria-label={isPlaying ? "توقف ویدیو" : "پخش ویدیو"}
          >
            {isPlaying ? (
              /* Pause Icon: Thin parallel lines */
              <svg className="w-3.5 h-3.5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <line x1="9" y1="4" x2="9" y2="20" />
                <line x1="15" y1="4" x2="15" y2="20" />
              </svg>
            ) : (
              /* Play Icon: Solid white triangle */
              <svg className="w-3.5 h-3.5 text-white ml-0.5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" fill="white" />
              </svg>
            )}
          </button>
        </div>

      </div>
    </div>
  );
}